"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable dot-notation */
const react_1 = __importStar(require("react"));
const UI_1 = require("~/components/UI");
const RadioButton_1 = __importDefault(require("~/components/common/controls/RadioButton"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const react_i18next_1 = require("react-i18next");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
const consts_1 = require("~/store/consts");
const types_1 = require("~/store/types");
const utils_1 = require("~/utils/utils");
const events_1 = require("~/utils/events");
const FastenersUtils_1 = require("~/components/Cad3d/utils/FastenersUtils");
const assets_1 = require("~/assets");
const Viewer_1 = __importDefault(require("~/components/Cad3d/Viewer"));
const FastenersGroup_1 = __importDefault(require("./FastenersGroup"));
const CurrentFastenerWidget_scss_1 = __importDefault(require("./CurrentFastenerWidget.scss"));
function CurrentFastenerWidget() {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const { data, isLoading, current } = (0, react_redux_1.useSelector)(selectors_1.selectDefaultFasteners);
    const defaultFasteners = (0, react_redux_1.useSelector)(selectors_1.selectProjectDefaultFasteners);
    const projectId = (0, react_redux_1.useSelector)(selectors_1.selectCurrentProjectId);
    const user = (0, react_redux_1.useSelector)(selectors_1.selectCurrentUser);
    const { dispatchToggleWidget, dispatchSetCurrentConnectionFasteners, dispatchAddFastenersToBOM } = (0, redux_1.bindActionCreators)({
        dispatchToggleWidget: actions_1.toggleWidget,
        dispatchSetCurrentConnectionFasteners: actions_1.setCurrentConnectionFasteners,
        dispatchAddFastenersToBOM: actions_1.requestAddFastenersToBOM,
    }, (0, react_redux_1.useDispatch)());
    const [selected, setSelected] = (0, react_1.useState)(undefined);
    const [processedConnectionUuids, setProcessedConnectionUuids] = (0, react_1.useState)([]);
    const [fastenerType, setFastenerType] = (0, react_1.useState)('');
    const [fastenerNumber, setFastenerNumber] = (0, react_1.useState)('');
    const quantity = (0, react_1.useRef)(1);
    const handleSelect = (fastener) => setSelected(fastener);
    const getConnectionUuidsByCurrentConnectionType = () => {
        return data.reduce((acc, curr) => {
            if (curr.connectionType === (current === null || current === void 0 ? void 0 : current.connectionType)) {
                acc.push(curr.connectionUuid);
            }
            return acc;
        }, []);
    };
    const setCurrentConnection = (connectionUuids) => {
        setProcessedConnectionUuids([...processedConnectionUuids, ...connectionUuids]);
        const processedConnectionUuidsLocal = [...processedConnectionUuids, ...connectionUuids];
        const newConnectionFasteners = data.find((connectionFasteners) => {
            return !processedConnectionUuidsLocal.includes(connectionFasteners.connectionUuid);
        });
        if (newConnectionFasteners) {
            dispatchSetCurrentConnectionFasteners(newConnectionFasteners);
        }
    };
    const getSeries = () => {
        var _a, _b;
        return ((_a = current === null || current === void 0 ? void 0 : current.mainItem.item) === null || _a === void 0 ? void 0 : _a.itemType.name) === types_1.ITEM_TYPE.EXTRUSION
            ? current === null || current === void 0 ? void 0 : current.mainItem.item.series[0]
            : (_b = current === null || current === void 0 ? void 0 : current.connectedItem.item) === null || _b === void 0 ? void 0 : _b.series[0];
    };
    const addFastenersToBOM = (itemNumber, connectionUuids, connections) => {
        const itemData = {
            connectionUuids,
            connections,
            itemNumber,
            projectId,
            quantity: quantity.current,
            size: 1,
            userId: user === null || user === void 0 ? void 0 : user.id,
            uuid: (0, utils_1.uuidv4)(),
        };
        dispatchAddFastenersToBOM([itemData]);
        document.body.dispatchEvent((0, events_1.addFastenersEvent)(itemData));
    };
    const getConnectionObjectAndConnectionByConnectionUUID = (connectionUUID) => {
        const viewer = Viewer_1.default.instance;
        const connectionObject = viewer.getObjectById(connectionUUID);
        if (!connectionObject) {
            return null;
        }
        const connection = connectionObject.getConnection();
        return [connectionObject, connection];
    };
    const calculateAndAddFasteners = (connectionUuids, itemNumber, visualizationParams) => __awaiter(this, void 0, void 0, function* () {
        yield Promise.all(connectionUuids.map((connectionUuid) => {
            const connectionEntries = getConnectionObjectAndConnectionByConnectionUUID(connectionUuid);
            if (!connectionEntries) {
                return null;
            }
            const [connectionObject, connection] = connectionEntries;
            if (connection.fastenerItemNumber === itemNumber) {
                return connectionObject;
            }
            return (0, FastenersUtils_1.updateFastenersForConnectionByUUID)(connectionUuid, itemNumber, visualizationParams);
        })).then((connectionObjects) => {
            Viewer_1.default.instance.collisionProcessor.updateCollisionsForObjectsAndConnections([], connectionObjects.filter((connectionObject) => connectionObject !== null));
            if (connectionObjects) {
                const connections = [];
                connectionObjects.forEach((connectionObject) => {
                    var _a;
                    const connection = connectionObject === null || connectionObject === void 0 ? void 0 : connectionObject.getConnection();
                    quantity.current = (_a = connection === null || connection === void 0 ? void 0 : connection.numberOfFasteners) !== null && _a !== void 0 ? _a : 1;
                    if (connection) {
                        connections.push(connection);
                    }
                });
                addFastenersToBOM(itemNumber, connectionUuids, connections);
            }
        });
    });
    const handleSave = () => __awaiter(this, void 0, void 0, function* () {
        const connectionUuids = getConnectionUuidsByCurrentConnectionType();
        if (selected) {
            calculateAndAddFasteners(connectionUuids, selected.item_number, {
                distanceToTheEdge: selected.distanceToTheEdge,
                holeDepth: selected.holeDepth,
            });
        }
        setSelected(undefined);
        dispatchToggleWidget({
            widgetName: consts_1.WIDGETS.CURRENT_FASTENER_WIDGET,
            show: false,
        });
        setCurrentConnection(connectionUuids);
    });
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if ((_a = current === null || current === void 0 ? void 0 : current.fasteners) === null || _a === void 0 ? void 0 : _a.length) {
            const series = getSeries();
            if (!series) {
                return;
            }
            const type = current === null || current === void 0 ? void 0 : current.connectionType;
            const defaultFastener = (_b = defaultFasteners === null || defaultFasteners === void 0 ? void 0 : defaultFasteners[series.id]) === null || _b === void 0 ? void 0 : _b[type];
            if (defaultFastener === null || defaultFastener === void 0 ? void 0 : defaultFastener.itemProperties) {
                setFastenerType(defaultFastener.itemProperties[0].value);
                setFastenerNumber(defaultFastener.item_number);
            }
        }
    }, [current]);
    return (react_1.default.createElement(UI_1.Widget, { widgetName: consts_1.WIDGETS.CURRENT_FASTENER_WIDGET, defaultPosition: {
            x: 352,
            y: 100,
        } },
        react_1.default.createElement("div", { className: CurrentFastenerWidget_scss_1.default.content }, isLoading === types_1.LOADING_STATE.COMPLETE ? (react_1.default.createElement("div", { className: CurrentFastenerWidget_scss_1.default.container },
            react_1.default.createElement("header", null,
                react_1.default.createElement("div", { className: CurrentFastenerWidget_scss_1.default.title }, t('current.title'))),
            react_1.default.createElement("div", { className: CurrentFastenerWidget_scss_1.default.warning },
                react_1.default.createElement("img", { src: assets_1.svgFlashError, className: CurrentFastenerWidget_scss_1.default.img }),
                react_1.default.createElement("div", { className: CurrentFastenerWidget_scss_1.default.text },
                    fastenerType,
                    " #",
                    fastenerNumber,
                    " ",
                    t('current.warning'),
                    ' ')),
            react_1.default.createElement("main", null,
                react_1.default.createElement(UI_1.Scrollable, { scrollbar: true },
                    react_1.default.createElement(react_1.default.Fragment, null, (_a = current === null || current === void 0 ? void 0 : current.fasteners) === null || _a === void 0 ? void 0 :
                        _a.map((group) => (react_1.default.createElement(FastenersGroup_1.default, { group: group, key: group.name, onSelect: handleSelect, selected: selected === undefined ? null : selected }))),
                        react_1.default.createElement("div", { className: CurrentFastenerWidget_scss_1.default['choice-no'] },
                            react_1.default.createElement(RadioButton_1.default, { onSelect: () => handleSelect(null), selected: selected === null }, "Apply No Fasteners")),
                        react_1.default.createElement("div", { className: CurrentFastenerWidget_scss_1.default.hint }, "You can use gussets, joining plates or brackets and snap them individually")))),
            react_1.default.createElement("footer", null,
                react_1.default.createElement(UI_1.Button, { onClick: handleSave, disabled: selected === undefined, variant: 'primary' }, "Save")))) : ('loading'))));
}
exports.default = CurrentFastenerWidget;
